import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { StepType } from '../../models/step-type.model';
import { StepComponent } from '../step/step.component';

@Component({
  selector: 'app-ii-step',
  templateUrl: './important-information-step.component.html',
  styleUrls: ['./important-information-step.component.scss']
})
export class ImportantInformationStepComponent extends StepComponent implements OnInit {
  constructor(translate: TranslateService) {
    super(translate);
  }

  public ngOnInit() {
    this.setTitle('MyProfile_GDPR_Title');
  }

  public modelChange() {
    const isValid = this.validate();
    this.stepModelChanged.emit({
      stepType: StepType.ImportantInformation,
      validState: isValid
    });
  }

  public termsAcceptingChanged() {
    this.modelChange();
  }

  public optionChanged() {
    this.modelChange();
  }

  private validate() {
    const valid =
      this.stepAccount.isAcceptedTerms &&
      this.stepAccount.outOptions.contactWithAdditionalServices !== undefined &&
      this.stepAccount.outOptions.contactWithMarketingMaterials !== undefined;

    return valid;
  }

  public onPdfLanguageChanged(pdfLanguage: string): void {
    this.stepAccount.pdfLanguage = pdfLanguage;
  }
}
